<atomic-text #atomictext></atomic-text>